import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { AuthService } from '../auth.service';
import { Router, RouterLink } from "@angular/router"
import { MatCard, MatCardContent } from '@angular/material/card';

import { MatError, MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton, MatAnchor } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css'],
    imports: [MatCard, MatCardContent, FormsModule, MatError, MatFormField, MatInput, MatButton, MatIcon, MatAnchor, RouterLink]
})
export class RegisterComponent implements OnInit {
  public registerUser;
  public warning = signal<string | null>(null);
  public successA = signal(false);
  public loading = signal(false);
  private dService;
  constructor(private auth:AuthService, private router:Router) { }

  ngOnInit(){
    this.registerUser = {userName: "", password: "", password2: ""};
  }

  onSubmit(){
    if(this.registerUser.userName.length > 0 && this.registerUser.password === this.registerUser.password2){
      console.log("success");
      this.loading.set(true);
      this.dService = this.auth.register(this.registerUser).subscribe((d)=>{
        this.successA.set(true);
        this.warning.set(null);
        this.loading.set(false);
      },
      (err)=>{
        this.successA.set(false);
        this.warning.set(err.error?.message || 'Registration failed');
        this.loading.set(false);
      });
    }else{
      console.log("failed");
      this.successA.set(false);
      this.warning.set("Please enter correct parameters");
      this.loading.set(false);
    }
  }
  ngOnDestroy(){
    this.dService?.unsubscribe();
  }

}
